import { useLoginData } from "component/common/loginData";
import Button from "component/ui/Button";
import FullPageLoader from "component/ui/fullPageLoader";
import Input from "component/ui/Input";
import SelectField from "component/ui/SelectField";
import Textarea from "component/ui/Textarea";
import { violationOption } from "helper/constant";
import { X } from "lucide-react";
import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { IoCloseCircleSharp } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { deleteProfileImage, userImageUpload } from "store/slice/auth";
import { userReports } from "store/slice/profile";

const ReportUser = ({ onClose, data }) => {
  const userData = useLoginData();
  const [formData, setFormData] = useState({
    evidenceImageUrlPath: [],
    evidenceImageUrl: [],
  });
  const dispatch = useDispatch();

  const handleFileSelect = async (files) => {
    const remainingPictures = 5 - formData?.evidenceImageUrl?.length;
    let file = files;
    if (files?.length > remainingPictures) {
      // Convert the object to an array of [key, value] pairs
      const entries = Object.entries(files);

      // Slice the array to get the first `n` elements
      const slicedEntries = entries.slice(0, remainingPictures);

      // Convert the sliced array back to an object
      file = Object.fromEntries(slicedEntries);
    }
    // Create a new FormData object for file upload
    const imageData = new FormData();
    // If file is an array of files (e.g. after slicing), append each file individually
    if (typeof file === "object" && file !== null) {
      Object.entries(file).forEach(([key, value]) => {
        imageData.append("file", value);
      });
    } else {
      // If there's a single file, append it directly
      imageData.append("file", file);
    }

    try {
      // Dispatch the upload action
      const data = await dispatch(
        userImageUpload(imageData, "userReportEvidence", "image")
      );
      console.log("data", data);
      if (data?.length > 0) {
        data?.map((item) => {
          console.log("item", item);
          let temp = { ...formData };
          temp.evidenceImageUrlPath.push(item?.path);
          temp.evidenceImageUrl.push(item?.fileName);
          setFormData(temp);
        });
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const handleSuccess = (status) => {
    if (status) {
      setFormData({});
      onClose();
    } else {
      setFormData((formData) => ({
        ...formData,
        isLoading: false,
      }));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData?.typeOfViolation) {
      setFormData((formData) => ({
        ...formData,
        typeOfViolationErr: "Please select type of violation",
      }));
      return;
    }
    if (!formData?.isChecked) {
      setFormData((formData) => ({
        ...formData,
        isCheckedErr:
          "Please confirm that the information provided is accurate before submitting the report.",
      }));
      return;
    }
    setFormData((formData) => ({
      ...formData,
      isLoading: true,
    }));
    const request = {
      language: "en",
      reportedUserId: data?.id,
      descriptionOfIncident: formData?.descriptionOfIncident,
      userName: userData?.name,
      userEmail: userData?.email,
      typeOfViolation: formData?.typeOfViolation,
      evidenceImageUrl: formData?.evidenceImageUrl,
    };
    dispatch(userReports(request, handleSuccess));
  };

  console.log("Sdadsad", formData);
  return (
    <div className="lg:w-2/5 md:w-[90%] w-[95%] rounded-lg md:p-8 p-3 max-h-[85vh]  bg-white relative overflow-y-scroll thin-scrollbar">
      {formData?.isLoading && <FullPageLoader />}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors"
        aria-label="Close modal"
      >
        <X size={20} />
      </button>
      {/* Report User */}
      <div className="w-full bg-white ">
        <h2 className="md:text-3xl text-2xl font-medium text-center">
          Report Form
        </h2>
        <form onSubmit={handleSubmit} className="mt-5">
          <div className="space-y-2 text-md font-semibold text-gray-700">
            <div className="grid grid-cols-[120px_10px_1fr] ">
              <span>Your Name</span>
              <span>:</span>
              <span className="pl-4 break-all">{userData?.name} </span>
            </div>
            <div className="grid grid-cols-[120px_10px_1fr] ">
              <span>Your Email</span>
              <span>:</span>
              <span className="pl-4 break-all">{userData?.email}</span>
            </div>
            <div className="grid grid-cols-[120px_10px_1fr] ">
              <span>User Name Reporting</span>
              <span>:</span>
              <span className="pl-4 break-all">{data?.name} </span>
            </div>
          </div>
          <div className="space-y-4 mt-4">
            <SelectField
              label="Types of Violation"
              isRequired
              id="gender"
              value={formData?.typeOfViolation}
              onChange={(val) =>
                setFormData(() => ({
                  ...formData,
                  typeOfViolation: val,
                  typeOfViolationErr: "",
                }))
              }
              options={violationOption}
              placeholder="Type of violance"
            />
            {formData?.typeOfViolationErr && (
              <div
                style={{ marginTop: "0rem" }}
                className="text-red-400 font-semibold text-xs"
              >
                {formData?.typeOfViolationErr}
              </div>
            )}
            <Textarea
              label="Describe the Incident"
              placeholder="Enter description"
              value={formData?.descriptionOfIncident}
              onChange={(e) =>
                setFormData(() => ({
                  ...formData,
                  descriptionOfIncident: e.target.value,
                }))
              }
            />

            <div className="flex items-center justify-between">
              <label className="block text-sm font-medium text-gray-700">
                Evidence
              </label>

              <input
                type="file"
                name="evidence"
                accept="image/*"
                id="evidence"
                multiple
                onChange={(e) => {
                  handleFileSelect(e.target.files);
                }}
                className="hidden"
              />

              <label
                htmlFor="evidence"
                className="cursor-pointer inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-brand-gradient rounded-full transition"
              >
                Upload
              </label>
            </div>
            <div className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 my-3 gap-4">
              {formData?.evidenceImageUrlPath?.map((image, imageIndex) => (
                <div
                  className="bg-gray-300 relative rounded-lg w-full h-24"
                  style={{
                    backgroundImage: `url("${image}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="absolute top-0 right-0">
                    <IoCloseCircleSharp
                      onClick={(value) => {
                        value.stopPropagation();
                        let temp = { ...formData };
                        temp.evidenceImageUrl = temp.evidenceImageUrl.filter(
                          (_, index) => index != imageIndex
                        );
                        temp.evidenceImageUrlPath =
                          temp.evidenceImageUrlPath.filter(
                            (_, index) => index != imageIndex
                          );

                        setFormData(temp);
                      }}
                      className="h-6 w-6 cursor-pointer"
                      color="red"
                    />
                  </div>
                </div>
              ))}
            </div>
            <div>
              <label className="text-sm">
                Declaration <span className="text-red-500">*</span>{" "}
              </label>
              <div className="flex items-start my-3">
                <input
                  type="checkbox"
                  id="declaration"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={(e) =>
                    setFormData(() => ({
                      ...formData,
                      isChecked: e.target.checked,
                      isCheckedErr: "",
                    }))
                  }
                  className="h-6 w-6 text-indigo-600 border-gray-300 rounded"
                />

                <label
                  htmlFor="declaration"
                  className="ml-2 text-md text-gray-900 cursor-pointer"
                >
                  By submitting this report, I confirm the accuracy of the
                  information provided.
                </label>
              </div>
              {formData?.isCheckedErr && (
                <div
                  style={{ marginTop: "-0.6rem" }}
                  className="text-red-400 font-semibold text-xs"
                >
                  {formData?.isCheckedErr}
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center justify-center my-5">
            <Button className="w-full">Submit</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportUser;
